<template>
  <div class="w-screen h-screen flex items-center justify-center">
    <Spinner :size="28" />
  </div>
</template>

<script setup lang="ts">
import Spinner from '@/shared/components/Spinner.vue'
import { signout } from '@dacr/auth'
import { apolloClient, routerApolloClient } from '@/shared/graphql/client'
import { analytics } from '@/shared/services/analytics'
import { useUserStore } from '@/shared/stores/user'
import { onBeforeMount } from 'vue'

const userStore = useUserStore()

onBeforeMount(async () => {
  userStore.reset()
  apolloClient.stop()
  routerApolloClient.stop()
  await signout()
  await Promise.all([
    apolloClient.clearStore(),
    routerApolloClient.clearStore(),
  ])
  analytics.reset()

  window.localStorage.clear()

  window.location.href = '/login'
})
</script>
